import { Container } from '@mui/material'
import { DelekReplacementsResponse, GetPriceListReplacements } from "api/delek"
import { CommonForm, CommonInputSearch } from "common/forms"
import ReplacementsMarkdown from "docs/replacements.mdx"
import { memo, useState } from "react"
import Replacements from "./Replacements"
import ReplacementsSchema, { initialFormState } from "./ReplacementsSchema"

const ReplacementsForm = () => {
  const [response, setResponse] = useState<DelekReplacementsResponse>(null)
  return (
    <>
      <CommonForm
        initialValues={initialFormState}
        validationSchema={ReplacementsSchema}
        onSubmit={async (values) => {
          const { data } = await GetPriceListReplacements(values.skuOrName)
          setResponse(data)
        }}
        render={() => (
          <Container>
            <CommonInputSearch
              placeholder="הקלד פריט או מס׳ קטלוגי"
              name="skuOrName"
            />
          </Container>
        )}
      />
      {response?.result && <Replacements data={response.data} />}
      <ReplacementsMarkdown />
    </>
  )
}

export default memo(ReplacementsForm)
